import axios from '../Backend';


export const getChangeLogs = async (fromDate) => {
    try {
        const path = fromDate ? `?date[gte]=${fromDate}` : ''
        const res = await axios.get(`/api/v2/changelog${path}`);
        const resData = res.data
        if (resData.status !== 'success') throw new Error('Error to fetch changelog')
        return resData
    } catch (e) {
        console.log('openContactOnCrm :: Error')
        console.log(JSON.stringify(e))
        if (e.response) {
            console.log('openContactOnCrm :: Response Error')
            console.log(JSON.stringify(e.response.data))
        }
        throw e
    }
}

